var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJoinRightOuter = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.25 11.75c.726 0 1.403-.206 1.978-.563q.348.385.772.686a4.75 4.75 0 1 1 0-7.747q-.424.302-.772.687A3.75 3.75 0 1 0 5.25 11.75m1.978-6.937A3.75 3.75 0 0 1 9 8a3.75 3.75 0 0 1-1.772 3.187A4.73 4.73 0 0 1 6 8c0-1.226.465-2.344 1.228-3.187m3.522 7.937A4.73 4.73 0 0 1 8 11.873c1.21-.86 2-2.275 2-3.873s-.79-3.013-2-3.873a4.75 4.75 0 1 1 2.75 8.623"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJoinRightOuter);
export default ForwardRef;